import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogContentText,
  DialogActions,
  Button,
  Paper,
  ListItem,
  List,
  ListItemButton,
  ListItemIcon,
  Box,
  ListItemText,
  Switch
} from '@mui/material';
import LinkIcon from '@mui/icons-material/Link';

import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import PowerSettingsNewIcon from '@mui/icons-material/PowerSettingsNew';
import Chip from '@mui/material/Chip';

import { useConnections } from 'hooks/useConnections';
import { renderLabelName } from 'utils/getLabelConnectors';
import useConnectionStore from '../../store/useConnectors';
import Excel from 'assets/images/auth/excel.png';
import SGBuildex from 'assets/images/auth/sgbuildex_result.webp';
import Autodesk from 'assets/images/auth/autodesk.webp';
import { useMemo, useRef } from 'react';
import { transformMetadata } from '../../utils/utils';

export default function ListActiveElementDialog({ open, onConfirm, onCancel }) {
  const fileInputRef = useRef(null);
  const dataConnect = useRef(null);
  const { setActiveConnection } = useConnectionStore();
  const { data: dataConnection = [], isFetching: isLoadingConnection, isError } = useConnections();

  const listActiveElement = useMemo(() => {
    return dataConnection.filter((res) => res.provider === 'sgbuildex').flatMap((res) => transformMetadata(res));
  }, [dataConnection]);

  const handleInactiveElement = (item) => {
    console.log(item);
    onConfirm(item)
  };
  
  return (
    <>
      <Dialog maxWidth="sm" fullWidth open={open} onClose={onCancel}>
        <DialogTitle id="alert-dialog-title">Active Element</DialogTitle>
        <DialogContent>
          <List sx={{ px: 1 }}>
            {listActiveElement?.map((item, index) => (
              <Paper
                key={index}
                elevation={0}
                sx={{
                  mb: 1,
                  // borderRadius: 2,
                  borderBottom: '1px solid',
                  borderColor: 'divider',
                  '&:hover': {
                    // boxShadow: 1,
                    // borderColor: 'primary.main',
                    cursor: 'pointer'
                  }
                }}
              >
                <ListItem disablePadding>
                  <ListItemButton sx={{ px: 1 }}>
                    <ListItemIcon sx={{ minWidth: 44 }}>
                      <Box component="img" src={item.img} alt={item.label} sx={{ width: 20, height: 20, objectFit: 'contain' }} />
                    </ListItemIcon>

                    <ListItemText
                      primary={item.name}
                      secondary={item.element_name}
                      primaryTypographyProps={{ fontSize: 12, fontWeight: 'bold' }}
                      secondaryTypographyProps={{ fontSize: 12 }}
                    />

                    <Button
                      size="small"
                      variant="contained"
                      color={'error'}
                      startIcon={<PowerSettingsNewIcon />}
                      onClick={() => handleInactiveElement(item)}
                      sx={{ textTransform: 'none' }}
                    >
                      Inactive
                    </Button>
                  </ListItemButton>
                </ListItem>
              </Paper>
            ))}
          </List>
        </DialogContent>
        <DialogActions>
          {/* <Button onClick={handleCloseExtraction}>Disagree</Button> */}
          <Button onClick={onCancel} autoFocus>
            CANCEL
          </Button>
        </DialogActions>
      </Dialog>
      {/* Hidden file input */}
    </>
  );
}
